import "./polyfills";

import "nvent-web/style/style.scss";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "nvent-web/App";
import { addFeatureClasses } from "nvent-web/utils/features";
import { initializeGoogleAnalytics } from "nvent-web/services/analytics";
import * as munchkin from "nvent-web/services/munchkin";
import * as logger from "nvent-web/services/logger";
import { ErrorBoundary } from "nvent-web/services/bugsnag";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("No root element");
}

addFeatureClasses();
initializeGoogleAnalytics();

if (munchkin.shouldLoad()) {
  munchkin.load().catch((error) => {
    logger.error("Failed to load marketto", error);
  });
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter basename={import.meta.env.VITE_BASENAME}>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
